<template>
  <SimCardDevicesGroup />
</template>

<script>
import SimCardDevicesGroup from './SimCardDevicesGroup/SimCardDevicesGroup.vue'
export default {
  components: {
    SimCardDevicesGroup
  }
}
</script>

<style scoped>

</style>
